
export abstract class LocalStorageServiceVM {

  abstract setData(key: string, data: any, encrypted?: boolean);
  abstract addData(key: string, data: any, encrypted?: boolean);
  abstract getData(key: string, encrypted?: boolean);
  abstract clearData();
}
